import { Loader } from 'react-feather';

function Spinner(props) {

    return (<>
        <Loader className="h-5 w-5 text-gray-200" aria-hidden="true" />
    </>)
}

export { Spinner };